// Components==============
import { faSignOut } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './BackButton.module.scss';
import { NavLink } from 'react-router-dom';
// =========================

export default function BackButton() {
    return (
        <NavLink to="/">
            <div styleName="wrapper">
                <button type="button">
                    <FontAwesomeIcon icon={faSignOut} />
                </button>
            </div>
        </NavLink>
    );
}
